import React, { useEffect, useState } from 'react';
import InformativoForm from './InformativoForm';
//import $ from 'jquery';
import api from '../../../services/api';
import loadingGif from '../../../img/loading-gif.gif';

export default function Informativo() {
	const [informativos, setInformativos] = useState([]);
	const [modalVisibleNovo, setModalVisibleNovo] = useState(false);
	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	//const [informativo, setInformativo] = useState();
	const [loading, setLoading] = useState(true);

	const novoInformativoModal = React.createRef();
	useEffect(() => {
		getInformativos();
	}, []);

	async function getInformativos() {
		//let self = this;
		setLoading(true);

		try {
			const response = await api.get('/admin/informativo/json');

			const { data, status } = response;

			if (status === 200) {
				////console.log(data);
				setInformativos(data);
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			alert('Error' + error);

			if (error.response.status === 401) {
				window.location.reload();
			}
			setLoading(false);
		}
	}

	function removeInfoList(informativo) {
		const p = [...informativos];
		let index = -1;
		for (let i = 0; i < p.length; i++) {
			if (p[i].id === informativo.id) {
				index = i;
			}
		}

		if (index !== -1) {
			p.splice(index, 1);
		}

		setInformativos([...p]);
	}

	async function remove(informativo, setStateRemove) {
		if (!window.confirm('Deseja realmente remover esse registro?'))
			return false;
		//const self = this;

		setStateRemove(true);

		try {
			const response = await api.delete('/admin/informativo/' + informativo.id);
			if (response.status === 200 && response.data === true) {
				//getInformativos();
				removeInfoList(informativo);
				setStateRemove(false);
			} else {
				////console.log(response.status);
				////console.log(response.data);
				alert('Ocorreu algum erro');
				setStateRemove(false);
			}
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401) {
				window.location.reload(false);
			}
		}

		/*
        $.ajax({
            url: '/admin/informativo/' + informativo.id,
            method: 'DELETE',
        })
        .then(function(data, status) {
            if (status == "success" && data === true) {
                self.getInformativos();
            }
        })
        */
	}

	function updateInformativos(info) {
		const p = [...informativos];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === info.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			////console.log(p[index]);
			p[index] = info;
			////console.log(p[index]);
		} else {
			p.push(info);
		}

		setInformativos([...p]);
	}

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='Informativo row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Informativos
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							data-toggle='modal'
							data-target='#novoInformativoForm'
							onClick={() => {
								setModalVisibleNovo(true);
								novoInformativoModal.current.resetForm();
							}}>
							Novo Informativo
						</button>
					</div>
				</h2>
				<InformativoForm
					ref={novoInformativoModal}
					elementId='novoInformativoForm'
					callback={updateInformativos}
					modalVisible={modalVisibleNovo}
					setModalVisible={setModalVisibleNovo}
				/>
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div className='card-body'>
						<div>
							<table className='table'>
								<thead>
									<tr>
										<th>Título</th>
										<th>Tag</th>
										<th>Conteúdo</th>
										<th>Situação</th>
										<th></th>
									</tr>
								</thead>

								{loading ? (
									<tbody>
										<tr>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
									</tbody>
								) : (
									<tbody>
										{informativos.map((informativo) => (
											<InformativoContainer
												informativo={informativo}
												remove={remove}
												updateInformativos={updateInformativos}
											/>
										))}
									</tbody>
								)}
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function InformativoContainer(props) {
	const { informativo, remove, updateInformativos } = props;

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	const [loading, setLoading] = useState(false);

	return (
		<tr key={informativo.id}>
			<InformativoForm
				item={informativo}
				elementId={'informativo' + informativo?.id + 'Form'}
				callback={updateInformativos}
				modalVisible={modalVisibleEdit}
				setModalVisible={setModalVisibleEdit}
			/>
			<td>{informativo.titulo}</td>
			<td>{informativo.tag}</td>
			<td>{informativo.conteudo}</td>
			<td>{informativo.situacao === 1 ? 'Ativo' : 'Inativo'}</td>
			<td>
				<div className='float-right'>
					<button
						onClick={(e) => {
							e.preventDefault();

							if (loading) return;

							//setInformativo(informativo);
							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#informativo' + informativo.id + 'Form'}>
						Editar
					</button>
					<button
						className='btn btn-sm btn-danger'
						onClick={() => remove(informativo, setLoading)}>
						{loading ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'Remover'
						)}
					</button>
				</div>
			</td>
		</tr>
	);
}
